import { useQuery } from "@tanstack/react-query";
import { Product } from "../types/product";
import { useRouter } from "next/router";
import productCore from "../core/product.core";
import { BundleCombination } from "../types/product";

export default function useBundleProductItems(bundleSelection: BundleCombination | undefined | null) {
  const { locale, isReady } = useRouter();

  const queryProductIds = bundleSelection?.items.map((item) => (item.isVariation ? item.parentProductId : item.productId));

  return useQuery({
    // only get products from variationParent because that will reutrn all inventory of child anyway
    queryKey: ["bundleProductItems", queryProductIds, locale],
    queryFn: async () => {
      const promises = bundleSelection!.items
        .map((item) => {
          if (!item.isVariation) {
            return [productCore.getSingle(item.productId, locale!)];
          } else {
            return [
              productCore.getSingle(item.parentProductId, locale!),
              productCore.getVariationChildren(item.parentProductId!, locale!),
            ];
          }
        })
        .flatMap((i) => i);

      const productsX = await Promise.all(promises);

      const a = productsX.filter((i) => i !== undefined);
      const b = a.flatMap((product) => product);
      return b;
    },
    enabled: isReady && !!bundleSelection && !!bundleSelection.items && bundleSelection.items.length > 0,
  });
}
